import { escapeRegExp } from '@/util/strings'

export interface MatchPart {
  text: string
  isMatch: boolean
}

// Marks every case-insensitive occurrence of the query, as the Vue 2 typeahead did.
export function matchParts(label: string, query: string): MatchPart[] {
  if (!query) return [{ text: label, isMatch: false }]

  return label
    .split(new RegExp(`(${escapeRegExp(query)})`, 'i'))
    .map((text, index) => ({ text, isMatch: index % 2 === 1 }))
    .filter(part => part.text)
}
